import { render, staticRenderFns } from "./StudyNewEdit.vue?vue&type=template&id=5ee5837a&"
import script from "./StudyNewEdit.vue?vue&type=script&lang=js&"
export * from "./StudyNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports